import { render } from "./13.vue?vue&type=template&id=722c31c9"
import script from "./13.vue?vue&type=script&lang=js"
export * from "./13.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__